import publicRequest from "./publicRequest";

const tokenInfo = (token) =>
  publicRequest({
    route: "/token",
    useAPI: false,
  });

export default tokenInfo;
